const categories = ['Default', 'Premium', 'Compensation', 'Account'];
export default categories;
